/**
 * AILyricAssistantWrapper Component
 * Wrapper for AI Lyric Assistant modal
 */

import React from 'react';
import { AILyricAssistant } from '../ai';
import { toast } from 'sonner';

export const AILyricAssistantWrapper = ({
  isOpen,
  onClose,
}) => {
  const handleInsertLyrics = (lyricData) => {
    // Store lyrics in project metadata or a dedicated lyrics track
    
    // For now, we'll add lyrics as project metadata
    // In a full implementation, this could create a lyric track or annotation layer
    toast.success(`Lyrics for "${lyricData.section}" section added!`);
  };

  return (
    <AILyricAssistant
      isOpen={isOpen}
      onClose={onClose}
      onInsertLyrics={handleInsertLyrics}
    />
  );
};

export default AILyricAssistantWrapper;
